import { reactive, ref, type Ref, toRef } from 'vue'
import type { FormKitNode } from '@formkit/core'

export default () => {
  const activeStep = ref('')
  const stepValidity = reactive<Record<string, { valid: Ref<boolean> }>>({})

  const stepPlugin = (node: FormKitNode) => {
    if (node.props.type == 'group') {
      // builds an object of the top-level groups
      stepValidity[node.name] = stepValidity[node.name] || {}

      node.on('created', () => {
        // use 'on created' to ensure context object is available

        stepValidity[node.name].valid = toRef(node.context!.state, 'valid')
      })

      // set the active tab to the 1st step
      if (activeStep.value === '') {
        activeStep.value = node.name
      }

      // Stop plugin inheritance to descendant nodes
      return false
    }
  }

  return { activeStep, stepValidity, stepPlugin }
}
